import { gql } from '@apollo/client';

import { getClient } from 'lane-shared/apollo';
import { NewProductDetails } from 'application-types';
import {
  CreateProductRequest,
  CreateProductResponse,
  GroupType,
  SellingPriceInput,
} from 'graphql-query-contracts';
import { convertToUUID } from 'uuid-encoding';

import { priceInputToComponents } from 'lane-shared/domains/billingPayments/helpers/priceInputToComponents';

export async function createProductMutation(
  newProductDetails: NewProductDetails,
  sellingPrice: SellingPriceInput,
  channelId: string
) {
  const {
    name,
    description,
    productCategoryId,
    chargeCodeId,
    costOffsetCodeId,
    creditAmount,
    markupChargeCodeId,
    adminFee,
    adminFeeChargeCodeId,
    adminFeeTax,
  } = newProductDetails;

  const createProductMutation = gql`
    mutation createProduct($createProductRequest: CreateProductRequest!) {
      createProduct(createProductRequest: $createProductRequest) {
        id
      }
    }
  `;

  const { amount, tax, markup } = priceInputToComponents(newProductDetails);

  return await getClient().mutate<
    { createProduct: CreateProductResponse },
    { createProductRequest: CreateProductRequest }
  >({
    mutation: createProductMutation,
    variables: {
      createProductRequest: {
        name,
        description,
        groupId: convertToUUID(channelId),
        groupType: GroupType.GroupTypeActivateChannel,
        productCategoryId,
        chargeCodeId,
        markupChargeCodeId,
        amount,
        tax,
        markup,
        creditAmount: creditAmount ? parseFloat(creditAmount) : undefined,
        sellingPrice,
        ...(adminFee &&
          adminFee.value !== '' && {
            adminFee: {
              value: Number(adminFee.value),
              adminFeeAmountType: adminFee.type,
            },
          }),
        ...(adminFeeChargeCodeId && {
          adminFeeChargeCodeId: convertToUUID(adminFeeChargeCodeId),
        }),
        ...(adminFeeTax &&
          adminFeeTax.value !== '' && {
            adminFeeTax: {
              rate: Number(adminFeeTax.value),
              taxAmountType: adminFeeTax.type,
            },
          }),
        ...(costOffsetCodeId
          ? { costOffsetCodeId: convertToUUID(costOffsetCodeId) }
          : {}),
      },
    },
  });
}
